module.exports = __webpack_public_path__ + "static/atlaskit-table-headless-b502729ce98f8971ca205841038f691b.png";